var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    staticClass: "company-applyment-module",
    attrs: {
      "element-loading-custom-class": "absolute-loading"
    }
  }, [_c('el-affix', {
    class: {
      'applyment-page-header-top': _vm.affixed,
      'applyment-page-header-shrink': _vm.sidebarFold,
      'applyment-page-header-unfold': !_vm.sidebarFold
    },
    attrs: {
      "offset": 80
    },
    on: {
      "change": _vm.handleAffixChange
    }
  }, [_c('el-card', [_c('div', {
    staticClass: "applyment-page-header"
  }, [_c('div', [_c('div', {
    staticClass: "status"
  }, [_vm._v(" " + _vm._s(_vm.applymentStatusFormat(_vm.detail.applymentStatus)) + " ")]), _c('div', {
    staticClass: "page-header-heading-left"
  }, [_c('div', {
    staticClass: "heading-title"
  }, [_vm._v("Transaction No.: " + _vm._s(_vm.detail.applymentNo))])]), _c('div', {
    staticClass: "page-header-heading-content"
  }, [_c('el-descriptions', {
    attrs: {
      "column": 4,
      "direction": "vertical"
    }
  }, [_c('el-descriptions-item', {
    attrs: {
      "label": "Transaction No."
    }
  }, [_vm._v(_vm._s(_vm.detail.applymentNo))]), _c('el-descriptions-item', {
    attrs: {
      "label": "Reviewer"
    }
  }, [_vm.canUserToggle ? [_c('user-toggle', {
    attrs: {
      "user": _vm.detail.auditor,
      "ownershipRole": "auditor"
    }
  })] : _c('span', [_vm._v(_vm._s(_vm.userNameFormat(_vm.detail.auditor)))])], 2), _c('el-descriptions-item', {
    attrs: {
      "label": "Coordinator"
    }
  }, [_vm.canUserToggle ? [_c('user-toggle', {
    attrs: {
      "user": _vm.detail.coordinator,
      "ownershipRole": "coordinator"
    }
  })] : _c('span', [_vm._v(_vm._s(_vm.userNameFormat(_vm.detail.coordinator)))])], 2)], 1)], 1)]), _c('div', {
    staticClass: "page-header-heading-right"
  }, [_c('div', {
    staticClass: "opts"
  }, [_c('el-button', {
    attrs: {
      "type": "text",
      "icon": "el-icon-tickets"
    },
    on: {
      "click": _vm.openOwnershipHistoryModal
    }
  }, [_vm._v("Ownership History")]), _c('el-button', {
    attrs: {
      "type": "text",
      "icon": "el-icon-tickets"
    },
    on: {
      "click": _vm.openStatusHistoryModal
    }
  }, [_vm._v("Status Track")]), _vm.detail.applymentStatus === 'QUOTING' && _vm.isApplymentAuth('quotation:coordinate') ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium",
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.handleReviseFinish
    }
  }, [_vm._v(" Revision Submit ")]) : _vm._e(), _vm.detail.applymentStatus === 'QUOTATION_AUDITING' && _vm.isApplymentAuth('quotation:audit') ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": _vm.handleAuditFinish
    }
  }, [_vm._v(" Finish Review ")]) : _vm._e()], 1)])])])], 1), _c('div', {
    staticClass: "step mt50"
  }, [_c('el-card', {
    attrs: {
      "shadow": "hover"
    }
  }, [_c('base-info', {
    ref: "baseInfoRef",
    attrs: {
      "detail": _vm.detail
    }
  })], 1)], 1), _c('div', {
    staticClass: "step mt40",
    attrs: {
      "id": "Step2"
    }
  }, [_c('el-card', [_c('fee-letter', {
    ref: "feeLetterRef",
    attrs: {
      "detail": _vm.detail
    },
    on: {
      "updateRevisionSubmitBtnLoading": _vm.updateRevisionSubmitBtnLoading
    }
  })], 1)], 1), _c('ownership-history', {
    ref: "ownershipModal",
    attrs: {
      "applymentId": _vm.detail.id
    }
  }), _c('status-history', {
    ref: "statusHistoryModal",
    attrs: {
      "applymentId": _vm.detail.id
    }
  }), _c('audit-modal', {
    ref: "auditModal"
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }